'use strict';

/**
 * Boots a single slider section element.
 * @param {HTMLElement} section
 */
function bootSlider(section) {
    // Prevent double-init
    if (section.dataset.csReady === '1') return;
    section.dataset.csReady = '1';

    const uid = section.id;

    /* ── Elements ── */
    const track    = section.querySelector('.cs-track');
    const label    = document.getElementById(uid + '_label');
    const subtitle = document.getElementById(uid + '_subtitle');
    const btnPrev  = document.getElementById(uid + '_prev');
    const btnNext  = document.getElementById(uid + '_next');
    const slideEls = Array.from(track.querySelectorAll('.cs-slide'));

    if (!track || !btnPrev || !btnNext || slideEls.length === 0) return;

    /* ── Metadata from data attribute ── */
    let slides = [];
    try {
        slides = JSON.parse(section.dataset.csSlides || '[]');
    } catch (e) {
        console.warn('[content-slider] Could not parse data-cs-slides on #' + uid, e);
    }

    const total = slideEls.length;
    let current  = 0;
    let isMoving = false;

    /* ── Hide all slides except first ── */
    slideEls.forEach(function (el, i) {
        el.style.position = i === 0 ? 'relative' : 'absolute';
        el.style.top      = '0';
        el.style.left     = '0';
        el.style.width    = '100%';
        if (i !== 0) {
            el.style.display   = 'none';
            el.style.opacity   = '0';
        }
    });

    /* Make the track a positioning context for absolute slides */
    track.style.position = 'relative';

    /* ── Update label & subtitle ── */
    function updateMeta() {
        const meta = slides[current] || {};
        if (label)    label.textContent    = meta.slideTitle    || '';
        if (subtitle) subtitle.textContent = meta.slideSubtitle || '';

        slideEls.forEach(function (el, i) {
            el.setAttribute('aria-hidden', i !== current ? 'true' : 'false');
        });

        btnPrev.disabled = total <= 1;
        btnNext.disabled = total <= 1;
    }

    /* ── Slide transition ── */
    function goTo(next) {
        if (isMoving || next === current || total <= 1) return;
        isMoving = true;

        const dir      = next > current ? 1 : -1;
        const outSlide = slideEls[current];
        const inSlide  = slideEls[next];

        /* Set incoming slide off-screen, make it visible in the DOM */
        inSlide.style.transition  = 'none';
        inSlide.style.transform   = 'translateX(' + (dir * 100) + '%)';
        inSlide.style.opacity     = '0';
        inSlide.style.display     = 'block';
        inSlide.style.position    = 'absolute';

        /* Force reflow so the browser registers the start position */
        void inSlide.offsetWidth;

        const easing = 'cubic-bezier(.4,0,.2,1)';
        const timing = '0.45s';

        outSlide.style.transition = 'transform ' + timing + ' ' + easing + ', opacity ' + timing + ' ease';
        inSlide.style.transition  = 'transform ' + timing + ' ' + easing + ', opacity ' + timing + ' ease';

        outSlide.style.transform  = 'translateX(' + (-dir * 100) + '%)';
        outSlide.style.opacity    = '0';
        inSlide.style.transform   = 'translateX(0)';
        inSlide.style.opacity     = '1';

        inSlide.addEventListener('transitionend', function handler() {
            inSlide.removeEventListener('transitionend', handler);

            /* Finalize outgoing */
            outSlide.style.display    = 'none';
            outSlide.style.transition = '';
            outSlide.style.transform  = '';
            outSlide.style.opacity    = '';
            outSlide.style.position   = 'absolute';

            /* Finalize incoming */
            inSlide.style.transition  = '';
            inSlide.style.position    = 'relative';

            current  = next;
            isMoving = false;
            updateMeta();
        });
    }

    /* ── Button events ── */
    btnPrev.addEventListener('click', function () {
        goTo((current - 1 + total) % total);
    });

    btnNext.addEventListener('click', function () {
        goTo((current + 1) % total);
    });

    /* ── Keyboard (when focus is inside the slider) ── */
    section.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo((current - 1 + total) % total); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo((current + 1) % total); }
    });

    /* ── Touch / swipe ── */
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 50) {
            delta < 0
                ? goTo((current + 1) % total)
                : goTo((current - 1 + total) % total);
        }
    }, { passive: true });

    /* ── Boot ── */
    updateMeta();
}

/**
 * Scans a root element (default: document) for all .cs-slider sections
 * and initializes any that haven't been booted yet.
 *
 * @param {HTMLElement|Document} [root=document]
 */
export function initContentSliders(root) {
    var ctx = root || document;
    var sliders = ctx.querySelectorAll('.cs-slider[id]');
    sliders.forEach(bootSlider);
}

/**
 * Initialize a single slider by its section element or its ID string.
 *
 * @param {HTMLElement|string} target
 */
export function initContentSlider(target) {
    var el = typeof target === 'string' ? document.getElementById(target) : target;
    if (el) bootSlider(el);
}
